import React, {useRef} from 'react';
import {useSelector} from 'react-redux';
import QRCode from 'react-qr-code';
import {saveAs} from 'file-saver';
import {
  DashboardHolder,
  DashboardInnerDescription,
  DashboardTitle
} from 'routes/App/dashboard/styles';
import {ButtonOutline} from 'components/buttons';
import {QrCodeDisplay, QrCodeHeaderRow} from 'routes/App/settings/styles';
import IconDownload from 'assets/IconDownload';

export const getStorefrontQrUrl = (slug) => {
  if (!slug) {
    return '';
  }

  const params = new URLSearchParams({
    utm_source: 'QR',
    utm_medium: 'QR Code',
    utm_id: slug
  });

  return `${
    process.env.REACT_APP_STOREFRONT_URL
  }/order/${slug}/menu?${params.toString()}`;
};

const StorefrontQrCode = () => {
  const qrRef = useRef(null);
  const slug = useSelector((state) => state.user.activeLocation?.Slug);
  const qrUrl = getStorefrontQrUrl(slug);

  if (!slug || !qrUrl) {
    return null;
  }

  const downloadQrCode = () => {
    const svg = qrRef.current?.querySelector('svg');
    if (!svg) {
      return;
    }

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);
    const canvas = document.createElement('canvas');
    const img = new Image();
    const blob = new Blob([svgString], {
      type: 'image/svg+xml;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const size = 1024;

    img.onload = () => {
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, size, size);
      ctx.drawImage(img, 0, 0, size, size);
      canvas.toBlob((pngBlob) => {
        if (pngBlob) {
          saveAs(pngBlob, `${slug}-qr-code.png`);
        }
        URL.revokeObjectURL(url);
      });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
    };
    img.src = url;
  };

  return (
    <DashboardHolder>
      <DashboardTitle className='WithLine mBottom titleMd'>
        Your QR Code
      </DashboardTitle>
      <QrCodeHeaderRow>
        <DashboardInnerDescription className='withIcon GreyText'>
          <span className='noBorder mLeft10'>
            Customers can scan this QR code to open your online ordering page.
            <br />
            Download it and use it on menus, flyers, table tents, posters, or
            in-store signage.
          </span>
        </DashboardInnerDescription>
        <ButtonOutline
          className='ButtonSmall withIcon'
          type='button'
          onClick={downloadQrCode}
        >
          <IconDownload />
          <span>Download QR Code</span>
        </ButtonOutline>
      </QrCodeHeaderRow>
      <QrCodeDisplay ref={qrRef}>
        <QRCode
          value={qrUrl}
          size={200}
          level='M'
          role='img'
          aria-label='Storefront online ordering QR code'
        />
      </QrCodeDisplay>
    </DashboardHolder>
  );
};

export default StorefrontQrCode;
